import { useCallback } from 'react';

import { useClickOutside } from '@libs/hooks/useClickOutside';
import { AnimatedNode } from '@ui/components/Animation';

import { PlayerStats as PlayerStatsType } from '@features/shared/api/typings';
import { PlayerShieldAvatar } from '@features/user/ui/PlayerShieldAvatar';
import { UsePlayerShieldPopoverProps } from '@features/user/ui/PlayerShieldPopover/usePlayerShieldPopover';

type Props = {
  stats?: PlayerStatsType;
  goToPlayerProfile?: () => void;
} & UsePlayerShieldPopoverProps;
export function PlayerShieldPopover({
  stats,
  isOpen,
  floatingRef,
  style,
  setIsOpen,
  goToPlayerProfile,
  onMouseLeave,
  onMouseEnter,
}: Props) {
  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);
  const outsideClickRef = useClickOutside<HTMLDivElement>(handleClose);

  return (
    <AnimatedNode animation="half-opacity" portal={document.body}>
      {isOpen && (
        <PlayerShieldAvatar
          size="m"
          style={style}
          ref={(el) => {
            floatingRef(el);
            outsideClickRef.current = el;
          }}
          stats={stats}
          goToPlayerProfile={goToPlayerProfile}
          onMouseLeave={onMouseLeave}
          onMouseEnter={onMouseEnter}
          popoverDescriptionsEnabled={false}
          isWidget={false}
        />
      )}
    </AnimatedNode>
  );
}
